import { RESET_ALL as RESET_ON_LOGOUT, danger } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';
import { __t, applyTranslations } from 'utils/language';

import type { Action, Dispatch, ThunkAction } from 'types';
import type {
  TikTokReporting,
  TikTokReportingAudienceComponentData,
  TikTokReportingState
} from 'modules/reporting/types';

applyTranslations(require('./instagram-posts-reporting-reducer.i18n.json'));

const { REPORTING } = API.END_POINTS;

const PROCESSING = 'tiktok-reporting/PROCESSING';
const LOADED = 'tiktok-reporting/LOADED';
const RESET = 'tiktok-reporting/RESET';
const LOADING_AUDIENCE_DATA = 'tiktok-reporting/LOADING_AUDIENCE_DATA';
const LOADED_AUDIENCE_DATA = 'tiktok-reporting/LOADED_AUDIENCE_DATA';

const initialState = {
  data: {},
  isLoading: true,
  audienceData: {
    isLoading: true,
    data: {}
  }
};

const setStatus = (status: boolean): Action => ({
  type: PROCESSING,

  payload: {
    status
  }
});

const reportLoaded = (data: Array<TikTokReporting>): Action => ({
  type: LOADED,

  payload: {
    data
  }
});

const setAudienceDataLoadingStatus = (isLoading: boolean): Action => ({
  type: LOADING_AUDIENCE_DATA,
  payload: isLoading
});

export const resetTikTokReport = (): Action => ({
  type: RESET
});

const audienceDataLoaded = (audienceData: TikTokReportingAudienceComponentData): Action => ({
  type: LOADED_AUDIENCE_DATA,

  payload: {
    audienceData
  }
});

export const fetchTikTokReport = (campaignId: number): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(setStatus(true));

  try {
    const url = REPORTING.getTikTokReport(campaignId);
    const response = await get(url);
    const data = response.data || {};

    return dispatch(reportLoaded(data));
  } catch (error) {
    logError(error);

    return dispatch(danger(__t('tiktok_report_reducer.fetch_error')));
  } finally {
    // dispatch(setStatus(false));
  }
};

export const fetchAudienceReachData = (campaignId: number): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(setAudienceDataLoadingStatus(true));

  try {
    const url = REPORTING.getTiktokAudienceData(campaignId);
    const response = await get(url, {}, { suppressGlobalNotification: true });
    const audienceData = response.data || {};

    return dispatch(audienceDataLoaded({ isLoading: false, data: audienceData }));
  } catch (error) {
    logError(error);

    return dispatch(danger(__t('tiktok_report_reducer.audience_data_fetch_error')));
  } finally {
    dispatch(setAudienceDataLoadingStatus(false));
  }
};

const handleProcessing = (state: TikTokReportingState, { status }): TikTokReportingState => ({
  ...state,
  isLoading: status
});

const handleLoaded = (state: TikTokReportingState, { data }): TikTokReportingState => ({
  ...state,
  data,
  isLoading: false
});

const handleAudienceDataLoaded = (state: TikTokReportingState, { audienceData }): TikTokReportingState => ({
  ...state,
  audienceData
});

const handleLoadingAudienceData = (state: TikTokReportingState, isLoading): TikTokReportingState => ({
  ...state,
  audienceData: { ...state.audienceData, isLoading }
});

export default createReducer<any, any>('tiktokReporting', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [PROCESSING]: handleProcessing,
  [LOADED]: handleLoaded,
  [LOADED_AUDIENCE_DATA]: handleAudienceDataLoaded,
  [LOADING_AUDIENCE_DATA]: handleLoadingAudienceData
});
